module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "justify-center": ""
    }
  }, [_c('item-list', {
    attrs: {
      "allowAdd": "",
      "allowDelete": "",
      "endpoint": _vm.endpoint + 'image-categories',
      "editRoute": "categoryEdit",
      "headers": _vm.headers,
      "name": "Categories",
      "permissions": "image-categories",
      "search": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78cff016","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categories.vue
// module id = 438
// module chunks = 1